import { render, staticRenderFns } from "./CrewCombinationDetails.vue?vue&type=template&id=487f2254&scoped=true"
import script from "./CrewCombinationDetails.vue?vue&type=script&lang=js"
export * from "./CrewCombinationDetails.vue?vue&type=script&lang=js"
import style0 from "./CrewCombinationDetails.vue?vue&type=style&index=0&id=487f2254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f2254",
  null
  
)

export default component.exports